/**
 * Where is this asset right now?
 *
 * The Assignments overview gets this worked out by the backend, but the
 * Assets tab already holds the full asset records, so the same rules are
 * applied here rather than firing a second request. Kept in one place so
 * the two tabs can never disagree about what "overdue" means.
 *
 * An assignment is *current* when it has started and has not ended. Once the
 * last one's end date is in the past and nothing replaced it, the asset is
 * overdue: the paperwork still says it is out and nobody booked it back in.
 */
const day = (value) => (value ? String(value).slice(0, 10) : null);

export const assignmentState = (asset, today = new Date().toISOString().slice(0, 10)) => {
  const current = [];
  const upcoming = [];
  const past = [];

  (asset?.assignments || []).forEach((a) => {
    const starts = day(a.date_from);
    const ends = a.ongoing ? null : day(a.date_to);
    if (starts && starts > today) upcoming.push(a);
    else if (ends && ends < today) past.push(a);
    else current.push(a);
  });

  past.sort((a, b) => (day(a.date_to) || '').localeCompare(day(b.date_to) || ''));
  upcoming.sort((a, b) => (day(a.date_from) || '').localeCompare(day(b.date_from) || ''));
  const last = past.length ? past[past.length - 1] : null;

  let status = 'unassigned';
  let daysOverdue = null;
  if (current.length) {
    status = 'assigned';
  } else if (last) {
    status = 'overdue';
    daysOverdue = Math.round((new Date(today) - new Date(day(last.date_to))) / 86400000);
  }

  return { status, current, upcoming, last, daysOverdue };
};

export default assignmentState;
